import type { PayloadAction } from "@reduxjs/toolkit"
import { createAppSlice } from "../../../../app/createAppSlice"
import type { TarotSliceState } from "./tarot-state"
import { ArrayUtil } from "../../../../app/utils/array.utils"
import { AppConstants } from "../../../../app/app-constants"
import { getTarotReadingReq } from "../data/services/tarot-service"
import ReactGA from 'react-ga4'

const initialState: TarotSliceState = {
  loading: false,
  question: "",
  showModal: false,
  pickedCardsIndex: [],
  revealedCards: false,
  cards: ArrayUtil.shuffleArray(AppConstants.cardsMap)
}

export const TarotSlice = createAppSlice({
  name: "TarotSlice",
  initialState,
  extraReducers(builder) {
    builder.addMatcher((action) => action.type.endsWith("/pending") &&  action.type.includes("TarotSlice"),
      (state) => {state.loading = true}
    ).addMatcher((action) => action.type.endsWith("/fulfilled") &&  action.type.includes("TarotSlice"),
      (state) => {state.loading = false}
    )
  },
  reducers: create => ({
    changeQuestionAct: create.reducer((state, action: PayloadAction<string>) => {
      state.question = action.payload
    }),
    hideLoadingAct: create.reducer(state => {
      state.loading = false
    }),
    showModalTarotAct: create.reducer((state, action: PayloadAction<boolean>) => {
      state.showModal = action.payload
    }),
    showLoading: create.reducer(state => {
      state.loading = true
    }),
    showLodingAct: create.reducer( (state, action: PayloadAction<boolean>) => {
        state.loading = action.payload
      },
    ),
    pickCardAct: create.reducer((state, action: PayloadAction<{index:number, row: number}>) => {
      state.pickedCardsIndex.push(action.payload)
    }),
    unPickCardAct: create.reducer((state, action: PayloadAction<{index: number, row: number}>) => {
      const index = state.pickedCardsIndex.findIndex(e => e.row === action.payload.row && e.index === action.payload.index)
      if(index !== -1){
        state.pickedCardsIndex.splice(index, 1)
      }
    }),
    revealCardsAct: create.reducer(state => {
      state.revealedCards = true
    }),
    getReadingAsync: create.asyncThunk(
      async (p : {cards: string[], question: string, language: string}) => (await getTarotReadingReq(p)),
      {
        fulfilled: (state, action) => {
          ReactGA.event({
            category: 'Tarot',
            action: 'Display Reading',
            label: 'web'
          })
          state.readingResult = action.payload
        },
        rejected: state => {
        },
      },
    ),
  }),
  selectors: {
    // selectCount: counter => counter.value,
    // selectStatus: counter => counter.status,
  },
})

export const { hideLoadingAct, showLoading, showLodingAct, showModalTarotAct, pickCardAct, unPickCardAct, revealCardsAct, getReadingAsync, changeQuestionAct } = TarotSlice.actions
